<div class="" style="padding: 0 60px;">
    <div class="row mt-3 border-bottom">
        <div class="col-11">
            <h6 style="color: #126db3;margin-left:-15px">
                {{"action_plan.statistics.title" | translate}}
            </h6>
        </div>
        <div class="col-1  d-flex justify-content-end" (click)="changeStatistic()">
            <i *ngIf="!openStatistic" class="fas fa-chevron-down text-secondary" style="cursor: pointer;"></i>
            <i *ngIf="openStatistic" class="fas fa-chevron-up text-secondary" style="cursor: pointer;"></i>
        </div>
    </div>
    <ng-container *ngIf="openStatistic">
        <div class="row my-2">
            <div class="col-12 mt-2">
                <h6 style="color: #126db3;margin-left:-15px"> {{"action_plan.statistics.action_plan" | translate}}</h6>
            </div>
            <div class="col-12">
                <div class="row charts">
                    <div class="col-12 col-lg-7 bg-white" #containerRef style="max-height: 420px;">
                        <app-horizontal-chart [data]="generalStatistics"></app-horizontal-chart>

                    </div>
                    <div class="col-12 col-lg-4 bg-white mt-3 mt-lg-0" #containerRef2 style="max-height: 420px;">

                        <app-pie-chart [data]="generalStatistics" [from]="'general'"></app-pie-chart>
                    </div>
                </div>
            </div>
        </div>


        <div class="row mt-3 border-top pt-2">
            <div class="col-11 mt-2">
                <h6 style="color: #126db3;margin-left: -15px;">
                    {{"action_plan.statistics.members" | translate}}
                </h6>
            </div>
            <div class="col-1 d-flex justify-content-end mt-2" (click)="changeMembers()">
                <i *ngIf="!openByMember" class="fas fa-chevron-down text-secondary" style="cursor: pointer;"></i>
                <i *ngIf="openByMember" class="fas fa-chevron-up text-secondary" style="cursor: pointer;"></i>
            </div>
        </div>
        <ng-container *ngIf="openByMember">
            <ng-container *ngFor="let user of byUserStatistics">
                <div class="row my-2">
                    <div class="col-12">
                        <ng-container *ngIf="user.user">
                            <h6 style="color: #126db3;margin-left: -15px;"> {{user.user?.usuario?.name}}</h6>
                        </ng-container>
                        <ng-container *ngIf="!user.user">
                            <h6 style="color: #126db3;margin-left: -15px;">
                                {{user.user_responsable?.nombre_responsable}}</h6>
                        </ng-container>
                    </div>
                    <div class="col-12">
                        <div class="row charts">
                            <div class="col-12 col-lg-7 bg-white" #containerRef style="max-height: 420px;">
                                <app-horizontal-chart [data]="user"></app-horizontal-chart>

                            </div>
                            <div class="col-12 col-lg-4 bg-white mt-3 mt-lg-0" #containerRef2
                                style="max-height: 420px;">
                                <app-pie-chart [data]="user" [from]="'users'"></app-pie-chart>

                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

        </ng-container>

    </ng-container>


</div>